import { createContext, useContext } from 'react';

// Toast context lives in its own file so the ToastProvider component file
// can export ONLY the component (keeps React Fast Refresh happy — mixed
// component/value exports break HMR).

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface ToastOptions {
  type?: ToastType;
  title: string;
  message?: string;
  // Per spec §0.6.11: success/info auto-dismiss 5 s, warning 8 s, error sticks.
  // Caller may override with an explicit duration in ms (>= 4000 for non-error
  // per spec §0.11 rule #10). Pass `Infinity` for sticky.
  durationMs?: number;
}

export interface ToastContextValue {
  show(opts: ToastOptions): number;
  dismiss(id: number): void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

export function useToast(): ToastContextValue {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error('useToast must be used inside <ToastProvider>');
  }
  return ctx;
}
